export default process.env.REACT_APP_CI_COMMIT_REF_SLUG === 'main'
  ? {
      ES_API_BASE_URL: 'https://api.equipmentshare.com',
      OMINICHANNEL_API_BASE_URL: 'https://omnichannel-api.equipmentshare.com',
      POINTCAST_API_BASE_URL: 'https://pointcast-api.equipmentshare.com',
      ES_CDN_BASE_URL: 'https://appcdn.equipmentshare.com',
      FLEET_APP_URL: 'https://app.estrack.com',
      WEBFLOW_BASE_PATH: '/rent',
      ACCOUNT_PATH: '/account',
      AUTH0_CONFIG: {
        CLIENT_ID: 'cCRuEqD8mb4EsSa11oSn3HdWIpkUon3F',
        DOMAIN: 'auth.estrack.com',
        AUDIENCE: 'https://api.equipmentshare.com',
      },
      RECAPTCHA_SITE_KEY: '6LeEkvgpAAAAABd5TN9cSPMjQcMwARmLXi-Bdywe',
      HEAPER_ENV: 'Production',
      LD_CLIENT_SIDE_ID: '65a6ae61438bfd102cd05b18',
      LD_XT_REPORTING_CLIENT_SIDE_ID: '66e48550eecc910ffee87e4f',
      GOOGLE_MAP_API_KEY: 'AIzaSyBFKGbLYqSzHy2SzMT-4PTrAcSrVcc0ZxY',
      GEOCODE_URL: 'https://maps.googleapis.com/maps/api/geocode',
    }
  : {
      ES_API_BASE_URL: 'https://staging-api.equipmentshare.com',
      OMINICHANNEL_API_BASE_URL: 'https://staging-omnichannel-api.equipmentshare.com',
      POINTCAST_API_BASE_URL: 'https://staging-pointcast-api.equipmentshare.com',
      ES_CDN_BASE_URL: 'https://staging-cdn.equipmentshare.com',
      FLEET_APP_URL: 'https://staging-app.estrack.com',
      WEBFLOW_BASE_PATH: '/rent',
      ACCOUNT_PATH: '/account',
      AUTH0_CONFIG: {
        CLIENT_ID: 'picPwPnwTXrCvum6dhcOug4r0YqLvX17',
        DOMAIN: 'staging-auth.estrack.com',
        AUDIENCE: 'https://staging-api.equipmentshare.com',
      },
      RECAPTCHA_SITE_KEY: '6LfUkNspAAAAAL-JNvnxnDGjU7V_E1uipWOHSztN',
      HEAPER_ENV: process.env.NODE_ENV === 'development' ? 'Sandbox' : 'Staging',
      LD_CLIENT_SIDE_ID: '65a6aed5225f680fcc2d2018',
      LD_XT_REPORTING_CLIENT_SIDE_ID: '66e48550eecc910ffee87e4e',
      GOOGLE_MAP_API_KEY: 'AIzaSyBFKGbLYqSzHy2SzMT-4PTrAcSrVcc0ZxY',
      GEOCODE_URL: 'https://maps.googleapis.com/maps/api/geocode',
    };
